// extracted by mini-css-extract-plugin
module.exports = {"teaserTitle":"TeaserHeading_teaserTitle__ShOGe","large":"TeaserHeading_large__bsoW0","titleVignette":"TeaserHeading_titleVignette__qr53g","premium":"TeaserHeading_premium__zebOj"};